import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fromJS } from 'immutable';
import validate from 'validate.js';
import { Callout } from '@silverrailtech/srtlibrary';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import {
	paymentMethodsTypes,
	paymentMethodsTypeVia,
} from '../../../constants/constants';
import { fetchBookingDetails } from '../../ManageBooking/actionsManageBooking';
import {
	submitPaymentApi,
	getExternalPaymentPciUrlApi,
	getExternalPaymentPciOperationStatusApi,
} from '../../apiBooking';
import {
	confirmationOptions,
	findConfirmationValues,
	getConditionsOfCarriageMap,
	handleAutoEmailConfirmation,
} from '../../utils';
import { formatPrice } from '../../../utils';
import MakePayment from './MakePayment';
import messages from './messagesMakePayment';
import messagesPayment from '../../../components/Payment/messagesPayment';
import ExtendedSnackbar from '../../../components/ExtendedSnackbar/ExtendedSnackbar';
import inlineStyles from './styles';
import {
	paymentConstraints,
	validateConfirmationHelper,
} from './makePaymentDialogConstraints';
import { gaEvent } from '../../../utils/googleAnalytics';
import { getPaymentContextType, validateCampaign } from '../../../api';
import {
	PCI_TELECOM_MODAL_CONFIG,
	isPciTelecomPayment,
	EXTERNAL_PAYMENT_STATUSES,
	KEY_IVR_MODAL_CONFIG,
	isKeyIvrPayment,
} from './utils';

const StyledDialog = styled(Dialog)(() => ({
	'& .MuiPaper-root': {
		...inlineStyles.dialogPaper,
	},
}));

const StyledDialogContent = styled(DialogContent)({
	...inlineStyles.dialogContent,
});

class MakePaymentDialog extends Component {
	static propTypes = {
		addressTypes: PropTypes.object,
		booking: PropTypes.object,
		cocMap: PropTypes.object,
		configBasedAuth: PropTypes.bool,
		countries: PropTypes.object,
		disableCustomerEmailSending: PropTypes.bool,
		exchangeMode: PropTypes.bool,
		id: PropTypes.string,
		ignoreDisableEmailSendingSuppliers: PropTypes.array,
		intl: PropTypes.object,
		onClose: PropTypes.func.isRequired,
		onExchangePay: PropTypes.func,
		onPaymentSuccess: PropTypes.func,
		open: PropTypes.bool.isRequired,
		provinces: PropTypes.object,
		states: PropTypes.object,
		exchangeBalance: PropTypes.string,
		handleWarning: PropTypes.func,
		voucherPaymentEnabled: PropTypes.bool,
	};

	static defaultProps = {
		id: 'srtMakePayment',
		disableCustomerEmailSending: false,
		ignoreDisableEmailSendingSuppliers: [],
		exchangeMode: false,
	};

	static isTermsOfServiceVisible = (type) => {
		const visibleOptions = [
			confirmationOptions.none,
			confirmationOptions.confirmed,
			confirmationOptions.manualNoInfo,
			confirmationOptions.creditCard,
			confirmationOptions.debitCard,
			confirmationOptions.loyaltyCard,
		];
		return visibleOptions.includes(type);
	};

	static resetVoucherData() {
		return {
			voucherCode: '',
			voucherPin: '',
			validatedVoucherBalance: null,
			validatedVoucherNumber: '',
			validatedVoucherCode: '',
			validatedVoucherCurrency: '',
			voucherAlertText: '',
		};
	}

	static resetPciTelecomData() {
		return {
			pciTelecomModalOpen: false,
			pciTelecomStatus: '',
			pciTelecomOperationId: '',
			pciTelecomTransactionId: '',
			pciTelecomAlertText: '',
		};
	}

	static resetKeyIvrData() {
		return {
			keyIvrModalOpen: false,
			keyIvrStatus: '',
			keyIvrOperationId: '',
			keyIvrTransactionId: '',
			keyIvrAlertText: '',
		};
	}

	initialConfirmationState = {
		type: '',
		method: '',
		firstName: '',
		middleName: '',
		lastName: '',
		cardNumber: '',
		cardNumberFirstSixDigits: '',
		cardNumberLastFourDigits: '',
		expiryDateDay: '1',
		expiryDateMonth: '1',
		expiryDateYear: '',
		sortCode: '',
		loyaltyCardProgram: '',
		loyaltyCardIdentifier: '',
		vdEmail: '',
		showAlternateEmail: false,
		isCardTypeAvailable: false,
		language: '',
	};

	initialState = {
		method: '',
		cardName: '',
		cardNumber: '',
		cardNumberFirstSixDigits: '',
		cardNumberLastFourDigits: '',
		expiryDateMonth: '',
		expiryDateYear: '',
		startDateMonth: '',
		startDateYear: '',
		issueNumber: '',
		securityCode: '',
		token: '',
		countryCode: null,
		address1: '',
		address2: '',
		city: '',
		postalCode: '',
		addressType: 'BUSINESS',
		stateOrProvince: '',
		paymentDue: {},
		errors: {},
		alertText: '',
		warning: '',
		bookingBillingWarningMessages: '',
		isFetching: false,
		isProcessingSubmit: false,
		confirmation: this.initialConfirmationState,
		termsOfServiceCheck: false,
		account: undefined,
		pciTelecomModalOpen: false,
		pciTelecomStatus: '',
		pciTelecomOperationId: '',
		pciTelecomTransactionId: '',
		pciTelecomAlertText: '',
		keyIvrModalOpen: false,
		keyIvrStatus: '',
		keyIvrOperationId: '',
		keyIvrTransactionId: '',
		keyIvrAlertText: '',
		hideOnAccount: false,
		voucherCode: '',
		voucherPin: '',
		validatedVoucherBalance: null,
		validatedVoucherNumber: '',
		validatedVoucherCode: '',
		validatedVoucherCurrency: '',
		voucherAlertText: '',
		isCheckingVoucher: false,
	};

	constructor(props) {
		super(props);
		this.state = {
			data: fromJS(this.initialState),
		};
		this.pollingInterval = null;
		this.keyIvrPollingInterval = null;
	}

	componentDidMount() {
		window.addEventListener('message', this.handleSycurioPayment);
	}

	shouldComponentUpdate(nextProps, nextState) {
		// Only re-render if open state changes
		if (this.props.open !== nextProps.open) {
			return true;
		}

		// Re-render if booking data changes
		if (this.props.booking !== nextProps.booking) {
			return true;
		}

		// Re-render if exchange balance changes
		if (this.props.exchangeBalance !== nextProps.exchangeBalance) {
			return true;
		}

		// Re-render if component state data changes
		if (!this.state.data.equals(nextState.data)) {
			return true;
		}

		return false;
	}

	componentWillUnmount() {
		window.removeEventListener('message', this.handleSycurioPayment);
		this.stopPciTelecomPolling();
		this.stopKeyIvrPolling();
	}

	static setConfirmationValues = (confirmationInfo, type) => {
		const availableTypes =
			confirmationInfo.BookingPaymentConfirmationOptions.map(
				(option) => option.BookingPaymentConfirmationType,
			);

		const isCardTypeAvailable =
			availableTypes.includes(confirmationOptions.debitCard) ||
			availableTypes.includes(confirmationOptions.creditCard) ||
			availableTypes.includes(confirmationOptions.loyaltyCard);

		const confirmationType = type || availableTypes[0];

		const optionValues = findConfirmationValues(
			confirmationType,
			confirmationInfo,
		);
		const refDate = new Date(Date.now());
		const cardTypeValue =
			optionValues && optionValues.BookingPaymentConfirmationValues
				? optionValues.BookingPaymentConfirmationValues[0]
						.BookingPaymentConfirmationValueType
				: '';

		return {
			type: confirmationType,
			method:
				optionValues &&
				optionValues.BookingPaymentConfirmationType !==
					confirmationOptions.loyaltyCard
					? cardTypeValue
					: '',
			loyaltyCardProgram:
				optionValues &&
				optionValues.BookingPaymentConfirmationType ===
					confirmationOptions.loyaltyCard
					? cardTypeValue
					: '',
			language: confirmationInfo.BookingPaymentConfirmationTicketLanguages
				.length
				? confirmationInfo.BookingPaymentConfirmationTicketLanguages[0]
						.BookingPaymentConfirmationTicketLanguageType
				: '',
			expiryDateYear: `${refDate.getFullYear()}`,
			expiryDateMonth: `${refDate.getMonth() + 1}`,
			expiryDateDay: `${refDate.getDate() + 1}`,
			isCardTypeAvailable,
		};
	};

	getBraintreeNonceFunctionRef = (getBraintreeNonce) => {
		this.getBraintreeNonce = getBraintreeNonce;
	};

	handlePciTelecomClick = () => {
		const data = this.state.data.toJS();
		const { paymentDue } = data;
		const {
			booking,
			intl: { formatMessage },
		} = this.props;

		this.setState((state) => ({
			data: state.data.merge({ isProcessingSubmit: true }),
		}));
		getExternalPaymentPciUrlApi(
			{ paymentDue, booking },
			(errorResponse) => {
				this.setState((state) => ({
					data: state.data.merge({
						isProcessingSubmit: false,
						pciTelecomAlertText:
							errorResponse.errorResponse?.message ||
							formatMessage(messagesPayment.lblPciTelecomUrlError),
					}),
				}));
			},
			(successResponse) => {
				const { externalPaymentPciUrl, externalPaymentPciOperationId } =
					successResponse.successResponse.data;
				window.open(externalPaymentPciUrl, '_blank', 'noopener,noreferrer');
				this.setState((state) => ({
					data: state.data.merge({
						isProcessingSubmit: false,
						pciTelecomOperationId: externalPaymentPciOperationId,
						pciTelecomModalOpen: true,
					}),
				}));
				// Start polling for payment status
				this.startPciTelecomPolling(externalPaymentPciOperationId);
			},
			paymentMethodsTypeVia.pciTelecom,
		);
	};

	handleClosePciTelecomModal = () => {
		this.stopPciTelecomPolling();
		this.setState((state) => ({
			data: state.data.merge({ pciTelecomModalOpen: false }),
		}));
	};

	stopPciTelecomPolling = () => {
		if (this.pollingInterval) {
			clearInterval(this.pollingInterval);
			this.pollingInterval = null;
		}
	};

	startPciTelecomPolling = (operationId) => {
		this.stopPciTelecomPolling();
		this.pollingInterval = setInterval(() => {
			getExternalPaymentPciOperationStatusApi(
				operationId,
				(errorResponse) => {
					this.setState((state) => ({
						data: state.data.merge({
							pciTelecomStatus: EXTERNAL_PAYMENT_STATUSES.FAILURE,
							pciTelecomAlertText:
								errorResponse.errorResponse?.message || 'Payment failed',
						}),
					}));
					this.stopPciTelecomPolling();
				},
				(successResponse) => {
					const status =
						successResponse.successResponse?.data
							?.externalPaymentPciOperationStatus;
					const transactionId =
						successResponse.successResponse?.data
							?.externalPaymentPciTransactionId;

					if (status === EXTERNAL_PAYMENT_STATUSES.SUCCESS) {
						this.setState((state) => ({
							data: state.data.merge({
								pciTelecomStatus: EXTERNAL_PAYMENT_STATUSES.SUCCESS,
								pciTelecomTransactionId: transactionId,
							}),
						}));
						this.stopPciTelecomPolling();
					} else if (status === EXTERNAL_PAYMENT_STATUSES.FAILURE) {
						this.setState((state) => ({
							data: state.data.merge({
								pciTelecomStatus: EXTERNAL_PAYMENT_STATUSES.FAILURE,
							}),
						}));
						this.stopPciTelecomPolling();
					} else {
						// Continue polling
						this.setState((state) => ({
							data: state.data.merge({
								pciTelecomStatus: status || EXTERNAL_PAYMENT_STATUSES.PENDING,
							}),
						}));
					}
				},
			);
		}, 3000);
	};

	static renderExternalPaymentModal = (
		data,
		{
			modalConfigMap,
			statusKey,
			openKey,
			onClose,
			titleMsg,
			doNotRefreshMsg,
			doNotRefreshBodyMsg,
			cancelCloseMsg,
		},
	) => {
		const modalConfig =
			modalConfigMap[data[statusKey]] || modalConfigMap.PENDING;
		const { Icon, iconColor } = modalConfig;

		return (
			<Dialog
				open={data[openKey] || false}
				onClose={onClose}
				maxWidth="sm"
				fullWidth
			>
				<DialogTitle>
					<FormattedMessage {...titleMsg} />
				</DialogTitle>
				<div style={inlineStyles.pciTelecomDialogContent}>
					{modalConfig.showTopCallout && (
						<Callout variant="error" style={{ marginBottom: 16 }}>
							<span style={{ fontWeight: 600 }}>
								<FormattedMessage {...doNotRefreshMsg} />
							</span>{' '}
							<FormattedMessage {...doNotRefreshBodyMsg} />
						</Callout>
					)}
					<div style={inlineStyles.pciTelecomIconContainer}>
						<Icon sx={{ fontSize: 24, color: iconColor }} />
					</div>
					{modalConfig.statusInBox ? (
						<div style={inlineStyles.pciTelecomStatusBox}>
							<Typography style={inlineStyles.pciTelecomStatusText}>
								<FormattedMessage {...modalConfig.statusText} />
							</Typography>
						</div>
					) : (
						<Typography style={inlineStyles.pciTelecomStatusText}>
							<FormattedMessage {...modalConfig.statusText} />
						</Typography>
					)}
					{modalConfig.showBodyCallout ? (
						<Callout variant="error">
							<FormattedMessage {...modalConfig.bodyText} />
						</Callout>
					) : (
						<Typography style={inlineStyles.pciTelecomBodyText} align="center">
							<FormattedMessage {...modalConfig.bodyText} />
						</Typography>
					)}
					<div style={inlineStyles.pciTelecomDialogActions}>
						<Button
							variant="contained"
							color={modalConfig.cancelColor}
							disabled={modalConfig.cancelDisabled}
							onClick={onClose}
						>
							<FormattedMessage {...cancelCloseMsg} />
						</Button>
						<Button
							variant="contained"
							color={modalConfig.confirmColor}
							disabled={modalConfig.confirmDisabled}
							onClick={onClose}
						>
							<FormattedMessage {...modalConfig.confirmBtnText} />
						</Button>
					</div>
				</div>
			</Dialog>
		);
	};

	renderPciTelecomModal = (data) =>
		MakePaymentDialog.renderExternalPaymentModal(data, {
			modalConfigMap: PCI_TELECOM_MODAL_CONFIG,
			statusKey: 'pciTelecomStatus',
			openKey: 'pciTelecomModalOpen',
			onClose: this.handleClosePciTelecomModal,
			titleMsg: messages.lblPciTelecomModalTitle,
			doNotRefreshMsg: messages.lblPciTelecomDoNotRefresh,
			doNotRefreshBodyMsg: messages.lblPciTelecomDoNotRefreshBody,
			cancelCloseMsg: messages.btnPciTelecomCancelClose,
		});

	handleKeyIvrClick = () => {
		const data = this.state.data.toJS();
		const { paymentDue } = data;
		const {
			booking,
			intl: { formatMessage },
		} = this.props;

		this.setState((state) => ({
			data: state.data.merge({ isProcessingSubmit: true }),
		}));
		getExternalPaymentPciUrlApi(
			{ paymentDue, booking },
			(errorResponse) => {
				this.setState((state) => ({
					data: state.data.merge({
						isProcessingSubmit: false,
						keyIvrAlertText:
							errorResponse.errorResponse?.message ||
							formatMessage(messagesPayment.lblKeyIvrUrlError),
					}),
				}));
			},
			(successResponse) => {
				const { externalPaymentPciUrl, externalPaymentPciOperationId } =
					successResponse.successResponse.data;
				window.open(externalPaymentPciUrl, '_blank', 'noopener,noreferrer');
				this.setState((state) => ({
					data: state.data.merge({
						isProcessingSubmit: false,
						keyIvrOperationId: externalPaymentPciOperationId,
						keyIvrModalOpen: true,
					}),
				}));
				this.startKeyIvrPolling(externalPaymentPciOperationId);
			},
			paymentMethodsTypeVia.keyIvr,
		);
	};

	handleCloseKeyIvrModal = () => {
		this.stopKeyIvrPolling();
		this.setState((state) => ({
			data: state.data.merge({ keyIvrModalOpen: false }),
		}));
	};

	stopKeyIvrPolling = () => {
		if (this.keyIvrPollingInterval) {
			clearInterval(this.keyIvrPollingInterval);
			this.keyIvrPollingInterval = null;
		}
	};

	startKeyIvrPolling = (operationId) => {
		this.stopKeyIvrPolling();
		this.keyIvrPollingInterval = setInterval(() => {
			getExternalPaymentPciOperationStatusApi(
				operationId,
				(errorResponse) => {
					this.setState((state) => ({
						data: state.data.merge({
							keyIvrStatus: EXTERNAL_PAYMENT_STATUSES.FAILURE,
							keyIvrAlertText:
								errorResponse.errorResponse?.message || 'Payment failed',
						}),
					}));
					this.stopKeyIvrPolling();
				},
				(successResponse) => {
					const status =
						successResponse.successResponse?.data
							?.externalPaymentPciOperationStatus;
					const transactionId =
						successResponse.successResponse?.data
							?.externalPaymentPciTransactionId;

					if (status === EXTERNAL_PAYMENT_STATUSES.SUCCESS) {
						this.setState((state) => ({
							data: state.data.merge({
								keyIvrStatus: EXTERNAL_PAYMENT_STATUSES.SUCCESS,
								keyIvrTransactionId: transactionId,
							}),
						}));
						this.stopKeyIvrPolling();
					} else if (status === EXTERNAL_PAYMENT_STATUSES.FAILURE) {
						this.setState((state) => ({
							data: state.data.merge({
								keyIvrStatus: EXTERNAL_PAYMENT_STATUSES.FAILURE,
							}),
						}));
						this.stopKeyIvrPolling();
					} else {
						this.setState((state) => ({
							data: state.data.merge({
								keyIvrStatus: status || EXTERNAL_PAYMENT_STATUSES.PENDING,
							}),
						}));
					}
				},
			);
		}, 3000);
	};

	renderKeyIvrModal = (data) =>
		MakePaymentDialog.renderExternalPaymentModal(data, {
			modalConfigMap: KEY_IVR_MODAL_CONFIG,
			statusKey: 'keyIvrStatus',
			openKey: 'keyIvrModalOpen',
			onClose: this.handleCloseKeyIvrModal,
			titleMsg: messages.lblKeyIvrModalTitle,
			doNotRefreshMsg: messages.lblKeyIvrDoNotRefresh,
			doNotRefreshBodyMsg: messages.lblKeyIvrDoNotRefreshBody,
			cancelCloseMsg: messages.btnKeyIvrCancelClose,
		});

	handleInit = (paymentInformation, account) => {
		// Handle Payment options
		const refDate = new Date(Date.now());
		const paymentDue = paymentInformation;

		const confirmationInfo = Object.assign(
			this.initialConfirmationState,
			MakePaymentDialog.setConfirmationValues(
				paymentDue.BookingConfirmationInformation,
			),
		);

		confirmationInfo.vdEmail =
			!this.props.exchangeMode &&
			paymentDue.BookingEmailForClaimVD &&
			paymentDue.BookingEmailForClaimVD?.length > 0
				? paymentDue.BookingEmailForClaimVD[0]
				: '';
		const hasOnaccount = paymentDue.BookingPaymentAcceptablePaymentTypes.find(
			(paymentMethodsType) =>
				paymentMethodsType.BookingPaymentCode === paymentMethodsTypes.onaccount,
		);
		// Create a Payment options for dropdown
		const { voucherPaymentEnabled } = this.props;

		const acceptablePaymentTypes = voucherPaymentEnabled
			? paymentDue.BookingPaymentAcceptablePaymentTypes
			: paymentDue.BookingPaymentAcceptablePaymentTypes.filter(
					(item) => item.BookingPaymentCode !== paymentMethodsTypes.voucher,
				);

		const paymentMethod =
			acceptablePaymentTypes[0] && acceptablePaymentTypes[0].BookingPaymentCode;
		const paymentVia =
			acceptablePaymentTypes[0] && acceptablePaymentTypes[0].BookingPaymentVia;

		paymentDue.paymentMethods = acceptablePaymentTypes.map((item) => {
			let suChargeFee = '';
			if (paymentDue.BookingPaymentHasCreditCardSurchargeFee) {
				suChargeFee = ` (${formatPrice(
					Number(item.BookingPaymentCreditCardSurchargeFeeValue),
					item.BookingPaymentCreditCardSurchargeFeeCurrency,
					this.props.intl,
				)})`;
			}

			return {
				code: item.BookingPaymentCode,
				name: `${item.BookingPaymentName}${suChargeFee}`,
				type: item.BookingPaymentType,
				via: item.BookingPaymentVia,
			};
		});

		const paymentAccountData =
			account && hasOnaccount
				? {
						cardName: account.AccountGroupPaymentInfoCardholder ?? '',
						cardNumber: account.AccountGroupPaymentInfoCardNumber ?? '',
						securityCode: account.AccountGroupPaymentInfoSecurityCode ?? '',
					}
				: {};

		const hideOnAccount = !!(
			paymentAccountData &&
			paymentAccountData.cardName &&
			paymentAccountData.cardNumber &&
			paymentAccountData.securityCode
		);

		const errors = paymentDue.paymentMethods.length
			? {}
			: {
					payment: this.props.intl.formatMessage(messages.errNoPaymentMethods),
				};

		this.initialState = {
			...this.initialState,
			paymentDue,
			method: paymentMethod,
			via: paymentVia,
			expiryDateMonth: `${refDate.getMonth() + 1}`,
			expiryDateYear: `${refDate.getFullYear()}`,
			addressType: 'BUSINESS',
			confirmation: confirmationInfo,
			account,
			errors,
			hideOnAccount,
		};

		const updates = { ...this.initialState, ...paymentAccountData };

		this.setState((state) => ({
			data: state.data.merge({
				...updates,
				isFetching: false,
			}),
		}));
	};

	// TODO update all components to use (path, values) signature for onChange method
	handleChangeField = (updates, path) => {
		this.setState((state) => {
			const { data } = state;
			let pendingChanges = updates;
			if (updates.type) {
				const hasCardTypeAvailable = data.getIn([
					'confirmation',
					'isCardTypeAvailable',
				]);
				if (
					hasCardTypeAvailable &&
					updates.type === confirmationOptions.manualNoInfo
				)
					return null;
				pendingChanges = Object.assign(
					pendingChanges,
					MakePaymentDialog.setConfirmationValues(
						data.getIn(['paymentDue', 'BookingConfirmationInformation']).toJS(),
						pendingChanges.type,
					),
					{ errors: {} },
				);
			}
			if (updates.method) {
				pendingChanges = Object.assign(
					pendingChanges,
					MakePaymentDialog.resetVoucherData(),
					MakePaymentDialog.resetPciTelecomData(),
					MakePaymentDialog.resetKeyIvrData(),
				);
			}
			const newData = path
				? data.mergeIn(path, pendingChanges)
				: data.merge(pendingChanges);
			return { data: newData };
		});
	};

	handleSnackBarClose = () => {
		this.setState((state) => ({
			data: state.data.merge({ alertText: '', warning: '' }),
		}));
	};

	handleClosePaymentDialog = (queryItems) => {
		const { onPaymentSuccess, onClose } = this.props;

		if (this.state.data.get('bookingBillingWarningMessages').length) {
			onPaymentSuccess(queryItems).then(() => {
				setTimeout(() => {
					onClose();
				}, 6000);
			});
		} else {
			onPaymentSuccess(queryItems).then(() => {
				onClose();
			});
		}
	};

	handleRemoveVoucher = () => {
		this.setState((state) => ({
			data: state.data.merge(MakePaymentDialog.resetVoucherData()),
		}));
	};

	handleCheckVoucherBalance = async () => {
		const { data } = this.state;
		const {
			booking,
			intl: { formatMessage },
		} = this.props;
		const { queryItems } = booking;

		const voucherCode = data.get('voucherCode');
		const voucherPin = data.get('voucherPin');

		if (voucherCode && voucherPin) {
			this.setState((state) => ({
				data: state.data.merge({ isCheckingVoucher: true }),
			}));
			await getPaymentContextType(
				{
					srtDistCode: queryItems.srtDistCode,
					srtChannelCode: queryItems.srtChannelCode,
					srtPOSCode: queryItems.srtPOSCode,
				},
				(errorResponse) => {
					const errorMessage =
						errorResponse.errorResponse?.message ||
						formatMessage(messagesPayment.lblVoucherIncorrect);
					this.setState((state) => ({
						data: state.data.merge({
							voucherAlertText: errorMessage,
							isCheckingVoucher: false,
						}),
					}));
				},
				(successResponse) => {
					const requester = successResponse.successResponse?.data?.requester;
					const context =
						successResponse.successResponse?.data?.contextSilverCampaign;

					const customerProfileId =
						booking.BookingExternalIdentification
							?.BookingExternalIdCustomerNumber || null;

					validateCampaign(
						{
							campaign_code: voucherCode,
							pin: voucherPin,
							channel_identifier: context,
							customer_profile_id: customerProfileId,
						},
						requester,
						(error) => {
							const errorMessage =
								error.errorResponse?.message ||
								formatMessage(messagesPayment.lblVoucherIncorrect);
							this.setState((state) => ({
								data: state.data.merge({
									validatedVoucherBalance: null,
									validatedVoucherNumber: '',
									validatedVoucherCode: '',
									validatedVoucherCurrency: '',
									voucherAlertText: errorMessage,
									isCheckingVoucher: false,
								}),
							}));
						},
						(success) => {
							if (success?.campaign_type !== 'VOUCHER') {
								this.setState((state) => ({
									data: state.data.merge({
										voucherAlertText: formatMessage(
											messagesPayment.lblVoucherIncorrect,
										),
										isCheckingVoucher: false,
									}),
								}));
								return;
							}

							this.setState((state) => {
								const voucherBalance = success.voucher.value_amount || 0;
								const paymentDueAmount = Number(
									state.data.getIn([
										'paymentDue',
										'BookingPaymentSummary',
										'BookingPaymentSummaryBalanceDue',
									]) || 0,
								);
								const isInsufficient =
									Number(voucherBalance) < paymentDueAmount;

								let updatedData = state.data.merge({
									validatedVoucherBalance: success.voucher.value_amount || null,
									validatedVoucherNumber: success?.voucher?.pin,
									validatedVoucherCode: success?.voucher?.campaign_code,
									validatedVoucherCurrency: success?.voucher?.value_currency,
									voucherAlertText: '',
									isCheckingVoucher: false,
								});

								if (isInsufficient) {
									updatedData = updatedData.mergeIn(['confirmation'], {
										type: confirmationOptions.manual,
									});
								}

								return { data: updatedData };
							});
						},
					);
				},
			);
		}
	};

	handleSycurioPayment = (event) => {
		const paymentDue = this.state.data.toJS()?.paymentDue;

		const sycurioURL =
			paymentDue.BookingPaymentSycurioUrl &&
			new URL(paymentDue.BookingPaymentSycurioUrl);

		// use the same URL for Sycurio as in the iframe src
		if (sycurioURL && event.origin === sycurioURL.origin) {
			const sycurioNonce = sycurioURL && JSON.parse(event.data);
			if (sycurioNonce.isSubmitted) {
				const { data } = this.state;
				const {
					intl: { formatMessage },
				} = this.props;

				this.setState((state) => ({
					data: state.data.merge({ isProcessingSubmit: true, errors: {} }),
				}));
				const dataState = data.toJS();
				const updates = {
					isProcessingSubmit: false,
					errors:
						validate(
							dataState,
							paymentConstraints(
								formatMessage,
								MakePaymentDialog.isTermsOfServiceVisible,
								false,
							),
							{ fullMessages: false },
						) || {},
				};

				this.handleSubmitPayment(
					// The DTO adapted to submit the Payment Api function to reuse it -  submitPaymentApi()
					{
						...dataState,
						braintreeNonce: sycurioNonce.paymentMethodId,
						cardName: sycurioNonce.cardholderName,
						expiryDateMonth: sycurioNonce.expirationMonth,
						expiryDateYear: sycurioNonce.expirationYear,
						countryCode: sycurioNonce.billingCountryCode,
						city: sycurioNonce.billingCity,
						postalCode: sycurioNonce.billingPostalCode,
						address1: sycurioNonce.billingStreet,
						token: sycurioNonce.transactionReference,
						confirmation: { type: 'MANUAL' },
						addressType: 'UNKNOWN',
					},
					updates,
				);
			}
		}
	};

	handleSubmitPayment = async (dataState, status) => {
		const { booking, disableCustomerEmailSending } = this.props;
		const { queryItems } = booking;
		const updates = status;

		await submitPaymentApi(
			{
				payment: dataState,
				booking,
			},
			(response) => {
				updates.alertText = response.errorResponse.message;

				this.setState((state) => ({
					data: state.data.merge(updates),
				}));
			},
			(successRes) => {
				this.setState((state) => ({
					data: state.data.merge({
						alertText: 'Payment Success',
						isProcessingSubmit: true,
					}),
				}));

				if (
					successRes.successResponse?.data.BookingBillingWarningMessages?.length
				) {
					const joinedMsg =
						successRes.successResponse.data.BookingBillingWarningMessages.join(
							'\n',
						);
					updates.bookingBillingWarningMessages = joinedMsg;
				} else {
					updates.bookingBillingWarningMessages = '';
				}

				const confirmationType = dataState.confirmation.type;
				const isConfirmed =
					booking.BookingOrders.length <= 1 &&
					![
						confirmationOptions.manualEach,
						confirmationOptions.confirmed,
						confirmationOptions.manual,
					].includes(confirmationType);
				const sendEmail =
					isConfirmed &&
					(booking.BookingOrders[0]?.BookingOrderStatus === 'BOOKED' ||
						booking.BookingOrders[0]?.BookingOrderStatus === 'TICKETED');

				if (!disableCustomerEmailSending && isConfirmed && sendEmail) {
					const userEmail = dataState.confirmation.vdEmail;
					handleAutoEmailConfirmation(userEmail, booking).then((response) => {
						this.setState((state) => ({
							data: state.data.merge(Object.assign(updates, response)),
						}));
						// Updates state is not set by the time this runs and is causing a race condition
						if (response.warning !== '')
							this.props.handleWarning(response.warning);
						if (response.alertText === '')
							this.handleClosePaymentDialog(queryItems);
					});
				} else {
					this.handleClosePaymentDialog(queryItems);
				}
			},
		);
	};

	onSubmitPayment = async () => {
		const { data } = this.state;
		const {
			exchangeMode,
			onExchangePay,
			intl: { formatMessage },
		} = this.props;

		this.setState((state) => ({
			data: state.data.merge({ isProcessingSubmit: true, errors: {} }),
		}));
		const dataState = data.toJS();

		const isPciTelecom = isPciTelecomPayment(dataState);
		const isKeyIvr = isKeyIvrPayment(dataState);
		const isBraintree =
			dataState.method === paymentMethodsTypes.braintree &&
			!isPciTelecom &&
			!isKeyIvr;
		const isVoucher = dataState.method === paymentMethodsTypes.voucher;
		const updates = {
			isProcessingSubmit: false,
			errors:
				validate(
					dataState,
					paymentConstraints(
						formatMessage,
						MakePaymentDialog.isTermsOfServiceVisible,
						isBraintree,
						isVoucher,
						isPciTelecom,
						isKeyIvr,
					),
					{ fullMessages: false },
				) || {},
		};
		let confirmationErrors;
		if (!exchangeMode) {
			const hasEmail =
				dataState.paymentDue.BookingEmailForClaimVD &&
				dataState.paymentDue.BookingEmailForClaimVD?.length > 0;
			const confirmationConstraints = validateConfirmationHelper(
				dataState.confirmation.type,
				hasEmail,
				formatMessage,
			);
			confirmationErrors = validate(
				dataState.confirmation,
				confirmationConstraints,
				{ fullMessages: false },
			);
		}

		if (isBraintree) {
			if (this.getBraintreeNonce) {
				try {
					const payload = await this.getBraintreeNonce({
						cardholderName: dataState.cardName,
						billingAddress: {
							postalCode: dataState.postalCode,
							streetAddress: dataState.address1,
							extendedAddress: dataState.address2,
							locality: dataState.city,
							countryCodeAlpha2: dataState.countryCode,
						},
					});
					dataState.braintreeNonce = payload.nonce;
				} catch (err) {
					updates.errors.braintree = err;
				}
			} else {
				updates.errors.braintree = true;
			}
		}

		if (!validate.isEmpty(confirmationErrors)) {
			updates.errors = { ...updates.errors, confirmation: confirmationErrors };
			if (updates.errors.termsOfServiceCheck)
				updates.alertText = updates.errors.termsOfServiceCheck;
		}
		if (isVoucher && updates.errors.validatedVoucherBalance) {
			updates.alertText = updates.errors.validatedVoucherBalance;
		}
		if (isPciTelecom && updates.errors.pciTelecomPaymentComplete) {
			updates.alertText = updates.errors.pciTelecomPaymentComplete;
		}
		if (isKeyIvr && updates.errors.keyIvrPaymentComplete) {
			updates.alertText = updates.errors.keyIvrPaymentComplete;
		}
		if (!validate.isEmpty(updates.errors)) {
			this.setState((state) => ({
				data: state.data.merge(updates),
			}));
		} else if (exchangeMode) {
			onExchangePay(dataState);
		} else {
			updates.errors = {};

			this.handleSubmitPayment(dataState, updates);
		}
	};

	render() {
		const {
			addressTypes,
			booking,
			cocMap,
			configBasedAuth,
			countries,
			disableCustomerEmailSending,
			exchangeMode,
			ignoreDisableEmailSendingSuppliers,
			onClose,
			open,
			provinces,
			states,
			exchangeBalance,
		} = this.props;

		const cancelAction = () => {
			gaEvent(
				exchangeMode
					? 'exchangeSubmitPaymentCancel'
					: 'orderSubmitPaymentCancel',
			);
			onClose();
		};
		const data = this.state.data.toJS();
		const disabled = data.isFetching || data.isProcessingSubmit;

		const sycurioPaymentMethod =
			data.paymentDue.BookingPaymentSycurioUrl != null &&
			!data.paymentDue.BookingPaymentClientToken;

		const actions = (
			<div className="row" style={inlineStyles.dialogActionsRoot}>
				<div className="col-12 col-sm-2 offset-sm-6">
					<Button
						variant="contained"
						id="srtMakePaymentClose"
						onClick={cancelAction}
						fullWidth
						disabled={disabled}
					>
						<FormattedMessage {...messages.btnCancel} />
					</Button>
				</div>

				<div className="col-12 col-sm-4">
					{!sycurioPaymentMethod && (
						// no need to show submit button. the submit button will used inside the iframe
						<Button
							variant="contained"
							id="srtMakePaymentSubmit"
							onClick={this.onSubmitPayment}
							fullWidth
							color="primary"
							disabled={
								disabled || !!data.errors.payment || !!data.errors.accountGroup
							}
						>
							<FormattedMessage {...messages.btnSubmit} />
						</Button>
					)}
				</div>
			</div>
		);

		return (
			<div>
				<StyledDialog
					open={open}
					onClose={cancelAction}
					disableEnforceFocus
					maxWidth={false}
				>
					<DialogTitle>
						<FormattedMessage {...messages.lblTitle} />
					</DialogTitle>
					<StyledDialogContent>
						<MakePayment
							booking={booking}
							exchangeBalance={exchangeBalance}
							paymentInfo={data}
							addressTypes={addressTypes}
							countries={countries}
							states={states}
							provinces={provinces}
							cocMap={cocMap}
							onChange={this.handleChangeField}
							onInit={this.handleInit}
							showTermsOfService={MakePaymentDialog.isTermsOfServiceVisible(
								data.confirmation.type,
							)}
							disableCustomerEmailSending={disableCustomerEmailSending}
							ignoreDisableEmailSendingSuppliers={
								ignoreDisableEmailSendingSuppliers
							}
							exchangeMode={exchangeMode}
							configBasedAuth={configBasedAuth}
							getBraintreeNonceFunctionRef={this.getBraintreeNonceFunctionRef}
							braintreeClientToken={data.paymentDue.BookingPaymentClientToken}
							sycurioPaymentMethod={sycurioPaymentMethod}
							onCheckVoucherBalance={this.handleCheckVoucherBalance}
							onRemoveVoucher={this.handleRemoveVoucher}
							onPciTelecomClick={this.handlePciTelecomClick}
							onKeyIvrClick={this.handleKeyIvrClick}
						/>
					</StyledDialogContent>
					<DialogActions>{actions}</DialogActions>
				</StyledDialog>
				<ExtendedSnackbar
					id="srtBookingPaymentSnackBar"
					open={
						data.alertText !== '' && data.bookingBillingWarningMessages === ''
					}
					message={data.alertText}
					onClose={this.handleSnackBarClose}
				/>
				{this.renderPciTelecomModal(data)}
				{this.renderKeyIvrModal(data)}
				{data.bookingBillingWarningMessages !== '' && (
					<ExtendedSnackbar
						id="srtBookingBillingWarningMessages"
						open={data.bookingBillingWarningMessages !== ''}
						message={data.bookingBillingWarningMessages}
						onClose={() => {
							this.setState((state) => ({
								data: state.data.merge({ bookingBillingWarningMessages: '' }),
							}));
						}}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	addressTypes: state.getIn(['settings', 'AddressTypeList']),
	countries: state.getIn(['settings', 'BillingCountries']),
	states: state.getIn(['settings', 'StateProvinceList']),
	provinces: state.getIn(['settings', 'CanadianProvincesList']),
	cocMap: getConditionsOfCarriageMap(
		state.getIn(['settings', 'ws.interface.conditionsofcarriage_fqps']),
		state.getIn(['shopping', 'query', 'locale']),
	),
	disableCustomerEmailSending:
		state.getIn(['settings', 'ws.feature.disable_customer_email_sending']) ===
		'true',
	ignoreDisableEmailSendingSuppliers: state.getIn([
		'settings',
		'ws.feature.ignore_disable_email_sending_suppliers',
	])
		? state
				.getIn([
					'settings',
					'ws.feature.ignore_disable_email_sending_suppliers',
				])
				.split(',')
				.map((item) => item)
		: null,
	configBasedAuth:
		state.getIn([
			'settings',
			'ws.interface.config_based.authentication_enabled',
		]) === 'true',
});

const mapDispatchToProps = (dispatch) => ({
	onPaymentSuccess: bindActionCreators(fetchBookingDetails, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(injectIntl(MakePaymentDialog));
